import axios from 'axios';
import NProgress from 'nprogress';
import store from '@/store';

const { __API_SERVER__ } = window;

console.log(process.env);
/* eslint-disable no-param-reassign */
const _axios = axios.create({
  baseURL: __API_SERVER__ || process.env.VUE_APP_API_SERVER || 'http://localhost:8610',
  timeout: false,
  params: {},
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'ko-KR; ko; ',
  },
});

function createAxiosResponseInterceptor(axiosInstance) {
  const interceptor = axiosInstance.interceptors.response.use(
    (response) => {
      NProgress.done();
      return response;
    },
    (error) => {
      NProgress.done();
      console.log(error);
      // Reject promise if usual error
      if (error.response.status !== 401) {
        return Promise.reject(error);
      }

      /*
       * When response code is 401, try to refresh the token.
       * Eject the interceptor so it doesn't loop in case
       * token refresh causes the 401 response
       */
      axiosInstance.interceptors.response.eject(interceptor);

      NProgress.start();

      return axiosInstance.post('/auth/token', {
        account: store.getters.account,
        refreshToken: localStorage.getItem('ttc-refresh-token'),
      }).then((response) => {
        NProgress.done();
        store.commit('setToken', response.data.token);
        // store.commit('setRefreshToken', response.data.refreshToken);

        error.response.config.headers.Authorization = `Bearer ${response.data.token}`;
        axiosInstance.defaults.headers.common.Authorization = error.response.config.headers.Authorization;
        error.response.config.url = error.response.config.url.replace(error.response.config.baseURL,
          '');
        return axiosInstance(error.response.config);
      }).catch(async (e) => {
        NProgress.done();
        await store.dispatch('signout');
        return Promise.reject(e);
      }).finally(() => createAxiosResponseInterceptor(axiosInstance));
    },
  );
}

_axios.interceptors.request.use(
  (config) => {
    NProgress.start();
    if (!config.headers.common.Authorization && localStorage.getItem('od-token') !== null) {
      config.headers.common.Authorization = `Bearer ${localStorage.getItem('od-token')}`;
      _axios.defaults.headers.common.Authorization = config.headers.common.Authorization;
    }

    return config;
  },
  (e) => {
    NProgress.done();
    return Promise.reject(e);
  },
);

createAxiosResponseInterceptor(_axios);

export default {
  install: (Vue) => {
    Vue.axios = _axios;
    window.axios = _axios;
    Object.defineProperties(Vue.prototype, {
      axios: {
        get() {
          return _axios;
        },
      },
      $axios: {
        get() {
          return _axios;
        },
      },
    });
  },
};

/* eslint-enable no-param-reassign */
